import moment from 'moment';
import { User } from '../../apis/users';
import { ClinicalReview } from './types';

export const today = () => moment().format('YYYY-MM-DD');

// Picking or changing the reviewer dates the review today; re-picking the same reviewer keeps the date.
export function nextClinicalReview(
  current: ClinicalReview | null | undefined,
  prescriberId: string,
  reviewedToday: string
): ClinicalReview | null {
  if (!prescriberId) return null;
  if (current && current.prescriber_id === prescriberId) return current;

  return { prescriber_id: prescriberId, reviewed_at: reviewedToday };
}

// The prescriber's name, with their email when another prescriber of the clinic has the same name.
export function reviewerLabel(prescriber: User, prescribers: User[]): string {
  const name = `${prescriber.forename} ${prescriber.surname}`;
  const sharesName = prescribers.some(
    (other) => other._id !== prescriber._id && `${other.forename} ${other.surname}` === name
  );

  return sharesName ? `${name} (${prescriber.username})` : name;
}
